export enum StudentViewMode {
  Basic = 'ael', //online
  Preview = 'preview', //online
  Offline = 'offline',
  SCORM = 'scorm', // online
  Public = 'public', // online
  Offline_SCORM = 'scorm_custom_hosted',
  TinCan = 'tincan', // does not exists yet
  Offline_TinCan = 'offline_tincan',
  ExportedPackaged_NullClient = 'exportedPackaged_NullClient',
}

export type OnlineStudentViewModes =
  | StudentViewMode.Basic
  | StudentViewMode.Public
  | StudentViewMode.SCORM
  | StudentViewMode.Preview;
export type OfflineStudentViewModes =
  | StudentViewMode.Offline
  | StudentViewMode.Offline_SCORM
  | StudentViewMode.TinCan
  | StudentViewMode.Offline_TinCan
  | StudentViewMode.ExportedPackaged_NullClient;

export const getStudentViewModeFromString = (value: string): StudentViewMode => {
  switch (value) {
    case 'ael':
      return StudentViewMode.Basic;
    case 'preview':
      return StudentViewMode.Preview;
    case 'offline':
      return StudentViewMode.Offline;
    case 'scorm':
      return StudentViewMode.SCORM;
    case 'public':
      return StudentViewMode.Public;
    case 'scorm_custom_hosted':
      return StudentViewMode.Offline_SCORM;
    case 'tincan':
      return StudentViewMode.TinCan;
    case 'offline_tincan':
      return StudentViewMode.Offline_TinCan;
    case 'exportedPackaged_NullClient':
      return StudentViewMode.ExportedPackaged_NullClient;
    default:
      return assertNever(value);
  }
};
const assertNever = (value: string): never => {
  throw new Error('Unknown value of StudentViewMode: ' + value);
};

export const assertNeverForViewMode = (viewMode: never): never => {
  throw new Error('Unknown StudentViewMode: ' + viewMode);
};
